import styled from 'styled-components';
import { FormFeedback } from 'reactstrap';
import { fontStyle } from '@whitelabel/helpers/style/type';

export const StyledFieldFeedback = styled(FormFeedback)`
  ${fontStyle('formSupport')}
  display: block;
  margin-top: 0.5rem;
`;
